.linkButton {
  text-decoration: none;
}

.strong {
  font-weight: 500;
}
